import styled from 'styled-components';

export const FilterLocationContainer = styled.div`
  width: 307px;
`;

export const FilterTypeContainer = styled.div`
  margin-bottom: 18px;
`;
